import {Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {AppDatePipe} from '@frontend/shared';

@Component({
  selector: 'app-questionnaire-header',
  imports: [TranslocoPipe, Button, AppDatePipe],
  templateUrl: './questionnaire-header.component.html',
})
export class QuestionnaireHeaderComponent {
  deadlineTranslationKey = input.required<string>();
  deadlineValue = input.required<string>();
  finishButtonTranslationKey = input.required<string>();
  canFinish = input.required<boolean>();
  isFinishing = input.required<boolean>();

  finishClick = output<void>();
}
